import { render } from "./AdminRejectRequest.vue?vue&type=template&id=0886bc96"
import script from "./AdminRejectRequest.vue?vue&type=script&lang=js"
export * from "./AdminRejectRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__